import { useState, useEffect } from 'react';
import { getImage, onImagesChanged } from '../services/mediaStore';

const NONE = { url: null, blob: null };

/** Loads the selected background image from IndexedDB as an object URL. */
export default function useBackgroundImage(imageId) {
  const [state, setState] = useState(NONE);
  // Bumped when images change, e.g. the selected one finishes downloading from the cloud.
  const [version, setVersion] = useState(0);
  useEffect(() => onImagesChanged(() => setVersion(v => v + 1)), []);

  useEffect(() => {
    if (!imageId) {
      setState(NONE);
      return undefined;
    }
    let cancelled = false;
    let url = null;
    getImage(imageId)
      .then((blob) => {
        if (cancelled) return;
        if (!blob) { setState(NONE); return; }
        url = URL.createObjectURL(blob);
        setState({ url, blob });
      })
      .catch(() => { if (!cancelled) setState(NONE); });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [imageId, version]);

  return state;
}
